// Sahiplik donemleri & kilitli gecmis — kullanici onayiyla canliya alindi (2026-06-25).
export const OWNERSHIP_V2 = true;

export const PERIOD_STATUS_LABELS = { aktif: "Aktif Dönem", kapali: "Kapanmış Dönem" };
